export const SET_SELECTED_SHIPMENTS = 'SET_SELECTED_SHIPMENTS';
export const setSelectedShipments = (selectedShipmentIds) => ({
  type: SET_SELECTED_SHIPMENTS,
  selectedShipmentIds,
});

export const CLEAR_SELECTED_SHIPMENTS = 'CLEAR_SELECTED_SHIPMENTS';
export const clearSelectedShipments = () => ({
  type: CLEAR_SELECTED_SHIPMENTS,
});
